import { createContext, useContext } from 'react';
import type { KaraokeAuthContextValue } from '~/modules/Auth/KaraokeAuthTypes';

export const KaraokeAuthContext = createContext<KaraokeAuthContextValue | null>(null);

export function useKaraokeAuth() {
  const context = useContext(KaraokeAuthContext);

  if (!context) {
    throw new Error('useKaraokeAuth must be used within KaraokeAuthProvider');
  }

  return context;
}
